import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // `html, body { height: 100%; overflow-y: scroll }` (App.css) makes <body>
    // its own scroll container instead of the window — window.scrollTo() alone
    // is a no-op there. Reset every plausible scrolling element so this works
    // regardless of which one actually holds the visible scroll position.
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
